const React = require("react");
const T = React.PropTypes;

require("./SectionOverview.less");

const PageType = require("~/types/Page.js").PropType;

const SectionOverview = React.createClass({
    propTypes: {
        Page: PageType.isRequired,
        IsReadOnly: T.bool.isRequired
    },
    render() {

        const rows = this.props.Page.Sections
            .sort((q1, q2) => {
                if (q1.DisplayOrder < q2.DisplayOrder) {
                    return -1;
                }

                if (q1.DisplayOrder > q2.DisplayOrder) {
                    return 1;
                }

                return 0;
            })
            .map(this.MakeRow);

        return (<div className="cs-SectionOverview">
                    <div className="cs-SectionOverview__rows">
                        <div className="cs-SectionOverview__header">
                            <div className="cs-SectionOverview__header__left">Section</div>
                            <div className="cs-SectionOverview__header__right">Score</div>
                        </div>
                        {rows}
                    </div>

        </div>);
    },
    MakeRow(s, i) {
        const pct = s.MaxScore === 0
            ? 0
            : (s.Score / s.MaxScore * 100).toFixed(0)

        return (<div key={i} className="cs-SectionOverview__Row">
                        <div className="cs-SectionOverview__SectionTitle" dangerouslySetInnerHTML={{ __html: s.TitleHTML }}></div>
                        <div className="cs-SectionOverview__SectionScore">
                            {s.Score}/{s.MaxScore}&nbsp;-&nbsp;{pct}%
                        </div>
        </div>);
    }

});

module.exports = SectionOverview;


// WEBPACK FOOTER //
// ./src/components/SurveySummary/SectionOverview/SectionOverview.jsx